import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { WalletDefaultProps } from 'src/containers/wallet-container/WalletPropTypes';
import { cloneDeep } from 'lodash-es';
import { WALLET_ACTIONS } from '../actions/WalletActions'; 

const initialState = () => ({
    currentRecord: cloneDeep(WalletDefaultProps),
    currentRecordPopulated: cloneDeep(WalletDefaultProps),

    search: {
        data: [],
        currentPage: 0,
        pages: 0,
        count: 0,
    },

    upsertReqStatus: null,
    searchReqStatus: null,
    bulkUpdateTransactionsReqStatus: null,
});

export default (state = initialState(), action) => {
    switch (action.type) {
        // SEARCH
        case WALLET_ACTIONS.WALLET_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case WALLET_ACTIONS.WALLET_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action.data,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case WALLET_ACTIONS.WALLET_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        // UPSERT
        case WALLET_ACTIONS.WALLET_UPSERT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case WALLET_ACTIONS.WALLET_UPSERT_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case WALLET_ACTIONS.WALLET_UPSERT_ERROR: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        case WALLET_ACTIONS.WALLET_EDIT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }

        // BULK UPDATE TRANSACTIONS
        case WALLET_ACTIONS.WALLET_BULK_UPDATE_TRANSACTIONS: {
            return {
                ...state,
                bulkUpdateTransactionsReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case WALLET_ACTIONS.WALLET_BULK_UPDATE_TRANSACTIONS_SUCCESS: {
            return {
                ...state,
                currentRecord: {
                    ...state.currentRecord,
                    transactions: action.transactions,
                },
                bulkUpdateTransactionsReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case WALLET_ACTIONS.WALLET_BULK_UPDATE_TRANSACTIONS_ERROR: {
            return {
                ...state,
                bulkUpdateTransactionsReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        // RESET
        case WALLET_ACTIONS.WALLET_RESET: {
            return initialState();
        }
        default:
            return state;
    }
};
